import {useState, useEffect, useCallback, useRef} from "react";

export function useFileDrag() {
    const [isDragging, setIsDragging] = useState(false);
    const dragCounter = useRef(0);

    const handleDragEnter = useCallback((event: DragEvent) => {
        event.preventDefault();
        dragCounter.current += 1;
        setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback((event: DragEvent) => {
        event.preventDefault();
        dragCounter.current -= 1;
        if (dragCounter.current === 0) {
            setIsDragging(false);
        }
    }, []);

    const handleDragOver = useCallback((event: DragEvent) => {
        event.preventDefault();
    }, []);

    const handleDrop = useCallback((event: DragEvent) => {
        event.preventDefault();
        dragCounter.current = 0;
        setIsDragging(false);
    }, []);

    useEffect(() => {
        window.addEventListener("dragenter", handleDragEnter);
        window.addEventListener("dragleave", handleDragLeave);
        window.addEventListener("dragover", handleDragOver);
        window.addEventListener("drop", handleDrop);

        return () => {
            window.removeEventListener("dragenter", handleDragEnter);
            window.removeEventListener("dragleave", handleDragLeave);
            window.removeEventListener("dragover", handleDragOver);
            window.removeEventListener("drop", handleDrop);
        };
    }, [handleDragEnter, handleDragLeave, handleDragOver, handleDrop]);

    return { isDragging };
}